<template>
  <b-container class="card-holder" fluid>
    <b-container fluid v-if="displaySurveyMenu && displayWineryMenu"
                 style="margin-left: 0px; width: 100%; border-radius: 30px;">
      <b-row align-h="center" no-gutters>
        <b-col sm="3" class="no-gutters">
          <b-container v-if="displaySurveyMenu && displayWineryMenu" fluid
                       style="border-radius: 15px;  padding: 10px 0;background-color:rgb(248, 248, 248)">
            <b-container fluid style="border-radius: 15px;  padding: 10px 0; background-color:rgb(248, 248, 248)">
              <ul :v-bind="menuObject" class="survey-tabs">

                <li v-for="value in  menuObject.items" :key="value.id">
                  <VineyardMenuItemV2 :ref=refName(value.id) :section="value.name" :value="value" :key="value.id"
                                      surveyKey="12345678990" :topLevelParent="value.name"></VineyardMenuItemV2>
                </li>
              </ul>
            </b-container>
          </b-container>
          <b-container fluid v-if="displayAdminSurveyMenu" class="admin-survey-list">
            <AdminSurveySelector v-if="!displaySurveyMenu"></AdminSurveySelector>
          </b-container>
        </b-col>
        <b-col sm="6" style="padding-left: 5px">
          <div>
            <b-container>
              <div style="background-color: rgba(111, 183, 80, 0.20);"
                   class="short-articles columns-content">
                <p>Thank you for taking the first step to become a Napa Green Certified Winery! Below is
                  an
                  overview of the steps in the certification process. Don’t let this overwhelm you.
                  It’s doable and
                  Napa Green staff is here to help.
                </p>
                <p><span style="color: darkgreen">Step 1 - Begin Answering Checklist Questions:</span>
                  Review the Application Checklist and work
                  with your core knowledge network (winemaker, facility/operations manager, cellar
                  manager,
                  whoever handles purchasing) to quickly answer many of the checklist questions.
                </p>

                <p><span style="color: darkgreen"> Step 2 - Integrated Resource Audit:</span> Once your
                  team has had a chance to review and begin
                  working on the Application Checklist reach out to Napa Green staff, who will send
                  you a few
                  forms to schedule the Integrated Resource Audit - a one-stop energy, water and waste
                  review
                  with a highly practical and experienced engineer from non-profit Sustainable Napa
                  County (~2-3
                  hours). As part of this audit your baseline energy use, water use and waste
                  diversion metrics will
                  be calculated and reviewed with your team. After the onsite review you will receive
                  a brief report
                  outlining opportunities and recommendations.
                </p>
                <p><span style="color: darkgreen"> Step 3 - Submit Application Checklist</span></p>
                <p><span style="color: darkgreen">Step 4 - Action Plan: </span>Based on your final
                  Application Checklist, onsite resource audit and
                  metrics Napa Green staff will help you develop an Action Plan for integrating and
                  streamlining
                  sustainability into your day-today operations over the next three years. Assign the
                  tasks on the
                  Action Plan to relevant staff and fill in rough expected deadlines.
                </p>

                <p><span style="color: darkgreen">Step 5 - Third-Party Certification:</span> Once the
                  Action Plan is finalized Napa Green staff will
                  connect you with the third-party certifier (the Napa County Green Business
                  Coordinator for the
                  statewide California Green Business Network) for the verification walkthrough (~1
                  hour).
                  If you have any questions along the way please contact Napa Green staff at
                  wegotthis@napagreen.org.
                </p>
              </div>
            </b-container>

          </div>
        </b-col>
        <b-col sm="3">
          <resource-links></resource-links>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid v-if="displaySurveyMenu && !displayWineryMenu "
                 style="margin-left: 0px; width: 100%; border-radius: 30px;">
      <b-row align-h="center" no-gutters>
        <b-col sm="4" class="no-gutters">
          <b-container v-if="displaySurveyMenu && displayWineryMenu" fluid
                       style="border-radius: 15px;  padding: 10px 0;background-color:rgb(248, 248, 248)">
            <b-container fluid style="border-radius: 15px;  padding: 10px 0; background-color:rgb(248, 248, 248)">
              <ul :v-bind="menuObject" class="survey-tabs">
                <li v-for="value in  menuObject.items" :key="value.id">
                  <VineyardMenuItemV2 :ref=refName(value.id) :section="value.name" :value="value" :key="value.id"
                                      surveyKey="12345678990" :topLevelParent="value.name"></VineyardMenuItemV2>
                </li>
              </ul>
            </b-container>
          </b-container>
          <b-container v-if="displaySurveyMenu && !displayWineryMenu" fluid
                       style="border-radius: 15px;  padding: 10px 0;background-color:rgb(248, 248, 248)">
            <b-container fluid style="border-radius: 15px;  padding: 10px 0; background-color:rgb(248, 248, 248)">
              <ul :v-bind="menuObject" class="survey-tabs">

                <li v-for="value in  menuObject.items" :key="value.id">
                  <VineyardMenuItemV2 :ref=refName(value.id) :section="value.name" :value="value" :key="value.id"
                                      surveyKey="12345678990" :topLevelParent="value.name"></VineyardMenuItemV2>
                </li>
              </ul>
            </b-container>
          </b-container>
          <b-container fluid v-if="displayAdminSurveyMenu" class="admin-survey-list">
            <AdminSurveySelector v-if="!displaySurveyMenu"></AdminSurveySelector>
          </b-container>
        </b-col>
        <b-col sm="8" style="padding-left: 5px">
          <div>
            <b-container fluid>
              <div style="background-color: rgba(111, 183, 80, 0.20);"
                   class="short-articles columns-content">
                <p><i><strong>“Wine producers can lead by showing the world what a low-carbon high life – a good life
                  that is compatible with a sustainable environment – looks like.”</strong> – </i>
                  <a href="https://www.decanter.com/learn/climate-change-wine-time-act-414297/"><i>Dr. Kim Nicholas</i></a>
                </p>
                <p>&nbsp;</p>
                <p>We are facing a climate crisis, and <a
                    href="https://www.conservation.org/video/nature-now-video-with-greta-thunberg">as Greta Thunberg
                  reminds us</a>, natural climate solutions are essential to turning things around. These solutions
                  don’t just benefit nature and benefit the climate – they can increase soil health, increase water and
                  nutrient retention and plant availability, increase the quality and yield of grapes on the vine,
                  increase resilience to a changing climate, and ultimately, increase profitability.&nbsp;</p>
                <p>&nbsp;</p>
                <p>A 2018 study focused on natural climate solutions for the United States found that <a
                    href="https://advances.sciencemag.org/content/4/11/eaat1869">natural climate solutions have the
                  potential to reduce net annual emissions in the U.S. by as much as 21%.</a> This study ranked the
                  potential of 21 natural climate solutions and found that reforestation, improved forest management,
                  cover crops, biochar, hedgerows and other alley cropping, and nutrient management were among six of
                  the top seven natural solutions with the greatest climate action potential.&nbsp;</p>
                <p>&nbsp;</p>
                <p>In addition to the need for urgent climate action, 2020 also brought to the fore a national reckoning
                  conversation about deeply ingrained social inequities and injustices in our society, and <a
                      href="https://migueld.medium.com/actionable-items-for-the-wine-community-43b5da61204c">specifically
                    within the wine industry</a>. <strong>We cannot have environmental or economic sustainability
                    without social sustainability</strong>.&nbsp;</p>
                <p>&nbsp;</p>
                <p>The Napa County wine industry is in a unique position to gain global recognition as a leader rapidly
                  scaling climate action in the agricultural sector, and making a renewed commitment in both words and
                  action to social equity, justice and inclusion. <strong>We recognize that</strong> <strong>our wine
                    region cannot solve climate change or social inequities, but we have a powerful leadership platform.
                    Our commitment to sustainability sets a standard that is recognized by the global wine industry,
                    beverage sector, and beyond.&nbsp;</strong></p>
                <p>&nbsp;</p>
                <p>As Miguel Garcia, Sustainable Agriculture Program Manager with the Napa County Resource Conservation
                  District (RCD), observes, “There is no reason all of the vineyards in Napa County can’t be carbon
                  neutral or negative.” <strong>Our goal is to assist growers in becoming carbon neutral within two
                    certification cycles (six years) and carbon negative, or climate positive, within three cycles (nine
                    years). </strong>Napa Green Certified Vineyards will exemplify agriculture that is giving back to
                  the land and communities.&nbsp;</p>
                <p>The new Napa Green Vineyard standards have six key elements.&nbsp;</p>
                <p>&nbsp;</p>
                <ul>
                  <li><strong>Social Equity, Justice and Inclusion</strong></li>
                  <li><strong>Carbon Farm Plans &amp; Regenerative Farming</strong></li>
                  <li><strong>Irrigation Assessments &amp; Water Efficiency</strong></li>
                  <li><strong>Tree &amp; Forest Preservation and Enhancement (where applicable)</strong></li>
                  <li><strong>Prohibited &amp; Restricted Pesticides</strong></li>
                  <li><strong>Conservation Burning or Burning Alternatives</strong></li>
                </ul>
                <p>&nbsp;</p>
                <p>These standards are both practice- and performance-based. Implementation of standards is validated by
                  independent third-party auditors. Ultimately, this next level stewardship certification is intended to
                  serve as an adaptable model for other wine regions and farming sectors</p>
                </p>
              </div>
            </b-container>

          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid v-if="displayAdminSurveyMenu"
                 style="margin-left: 0px; width: 100%; border-radius: 30px;">
      <b-row align-h="center" no-gutters>
        <b-col sm="3" class="no-gutters">
          <b-container v-if="displaySurveyMenu && displayWineryMenu" fluid
                       style="border-radius: 15px;  padding: 10px 0;background-color:rgb(248, 248, 248)">
            <ul v-bind="surveys" class="survey-tabs">

              <li v-for="(value, key) in surveys">
                <TabHeaderHome :ref=refName(key) :section="key" v-model="surveys[key]"
                               :surveyKey="surveyData.surveyKey"></TabHeaderHome>
              </li>
            </ul>
          </b-container>
          <b-container v-if="displaySurveyMenu && !displayWineryMenu" fluid
                       style="border-radius: 15px;  padding: 10px 0;background-color:rgb(248, 248, 248)">
            <b-container fluid style="border-radius: 15px;  padding: 10px 0; background-color:rgb(248, 248, 248)">
              <ul :v-bind="menuObject" class="survey-tabs">

                <li v-for="value in  menuObject.items" :key="value.id">
                  <VineyardMenuItemV2 :ref=refName(value.id) :section="value.name" :value="value" :key="value.id"
                                      surveyKey="12345678990" :topLevelParent="value.name"></VineyardMenuItemV2>
                </li>
              </ul>
            </b-container>
          </b-container>
          <b-container fluid v-if="displayAdminSurveyMenu" class="admin-survey-list">
            <AdminSurveySelector v-if="!displaySurveyMenu"></AdminSurveySelector>
          </b-container>
        </b-col>
        <b-col sm="9" style="padding-left: 5px">
          <div>
            <b-container fluid>
              <div style="background-color: rgba(111, 183, 80, 0.20);"
                   class="short-articles columns-content">
                <p>Thank you for taking the first step to become a Napa Green Certified Winery! Below is
                  an
                  overview of the steps in the certification process. Don’t let this overwhelm you.
                  It’s doable and
                  Napa Green staff is here to help.
                </p>
                <p><span style="color: darkgreen">Step 1 - Begin Answering Checklist Questions:</span>
                  Review the Application Checklist and work
                  with your core knowledge network (winemaker, facility/operations manager, cellar
                  manager,
                  whoever handles purchasing) to quickly answer many of the checklist questions.
                </p>

                <p><span style="color: darkgreen"> Step 2 - Integrated Resource Audit:</span> Once your
                  team has had a chance to review and begin
                  working on the Application Checklist reach out to Napa Green staff, who will send
                  you a few
                  forms to schedule the Integrated Resource Audit - a one-stop energy, water and waste
                  review
                  with a highly practical and experienced engineer from non-profit Sustainable Napa
                  County (~2-3
                  hours). As part of this audit your baseline energy use, water use and waste
                  diversion metrics will
                  be calculated and reviewed with your team. After the onsite review you will receive
                  a brief report
                  outlining opportunities and recommendations.
                </p>
                <p><span style="color: darkgreen"> Step 3 - Submit Application Checklist</span></p>
                <p><span style="color: darkgreen">Step 4 - Action Plan: </span>Based on your final
                  Application Checklist, onsite resource audit and
                  metrics Napa Green staff will help you develop an Action Plan for integrating and
                  streamlining
                  sustainability into your day-today operations over the next three years. Assign the
                  tasks on the
                  Action Plan to relevant staff and fill in rough expected deadlines.
                </p>

                <p><span style="color: darkgreen">Step 5 - Third-Party Certification:</span> Once the
                  Action Plan is finalized Napa Green staff will
                  connect you with the third-party certifier (the Napa County Green Business
                  Coordinator for the
                  statewide California Green Business Network) for the verification walkthrough (~1
                  hour).
                  If you have any questions along the way please contact Napa Green staff at
                  wegotthis@napagreen.org.
                </p>
              </div>
            </b-container>

          </div>
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
import NavMenu from "./NavMenu";
import * as SurveyVue from 'survey-vue'
import TabHeader from "./TabHeader";
import pdf from 'vue-pdf';
import TabHeaderHome from "./TabHeaderHome";
import AdminSurveySelector from "./AdminSurveySelector";
import Bus from "../eventBus";
import {globalStore} from "../main";
import axios from "axios";
import ResourceLinks from "./ResourceLinks";
import VineyardMenuItemV2 from "@/components/vineyard/VineyardMenuItemV2";

let Survey = SurveyVue.Survey;

Survey.cssType = "bootstrap";

SurveyVue.JsonObject.metaData.addProperty(
    'questionBase', {name: 'questionId'}
);
SurveyVue.JsonObject.metaData.addProperty(
    'questionBase', {name: 'greenNote'}
);
SurveyVue.JsonObject.metaData.addProperty(
    'page', {name: 'section'}
);
SurveyVue.JsonObject.metaData.addProperty(
    'page', {name: 'helpText'}
)

const separator = {
  template: `<hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">`
};
let json = "";

Array.prototype.groupBy = function (prop) {
  return this.reduce(function (groups, item) {
    const val = item[prop];
    groups[val] = groups[val] || [];
    groups[val].push(item);
    return groups
  }, {})
}

function getSum(total, num) {
  return total.add(num);
}

function doReduction(pages) {
  return pages.map(function thing(page1) {
    return {section: page1.section, name: page1.name};
  }).groupBy('section');
}

export default {
  components: {
    ResourceLinks,
    AdminSurveySelector,
    TabHeaderHome,
    NavMenu,
    Survey, // Type of the component
    TabHeader,
    VineyardMenuItemV2,
    pdf
  },
  data() {
    let model = new SurveyVue.Model(json);
    return {
      isAdmin: true,
      surveyData: {},
      survey: model,
      item: {},
      json: '',
      collapsed: false,
      themes: ['', 'white-theme'],
      selectedTheme: 'default-theme',
      surveys: {},
      menuObject: {}
    }
  }
  ,
  created() {
    Bus.$on('show-sidebar', this.isDisplayed);

  },
  beforeDestroy() {
    Bus.$on('show-sidebar', this.isDisplayed);
  },
  computed: {
    displaySurveyMenu: function () {
      return !(localStorage.getItem("roles").includes("admin") || localStorage.getItem("roles").includes("THIRD_PARTY_CERTIFIER")
          || localStorage.getItem("roles").includes("VINEYARD_ADMIN"));
    },
    displayAdminSurveyMenu: function () {
      return localStorage.getItem("roles").includes("admin") ||
          localStorage.getItem("roles").includes("THIRD_PARTY_CERTIFIER") ||
          localStorage.getItem("roles").includes("VINEYARD_ADMIN");
    },
    displayWineryMenu: function () {
      console.log("Check entityType!");
      return localStorage.getItem("entityType") === "WINE";
    },

  },

  methods: {
    isDisplayed: function (value) {
      globalStore.isAdmin = value;
      this.isAdmin = globalStore.isAdmin;
    },
    isChecklistUser: function () {
      console.log("Logging in.");
      //return localStorage.getItem("roles").contains("user");
      return false;
    },
    goToMyTeam: function () {
      console.log("Logging in.");
      this.$router.push({path: '/groups'});
    },
    goToAccountInfo: function () {
      console.log("Logging in.");
      this.$router.push({path: '/update-account-info'});
    },
    goToUpdatePassword: function () {
      console.log("Logging in.");
      this.$router.push({path: '/update-password'});
    }
    ,
    goToMySurvey: function () {
      console.log("Logging in.");
      this.$router.push({path: '/survey?surveyId=1'});
    },
    refName: function (name) {
      return 'poo' + name;
    }
    , download: async function () {
      let url = "/static/epp_policy_template.docx";
      axios.get(url, {responseType: 'blob'})
          .then(({data}) => {
            const blob = new Blob([data], {type: 'application/docx'})
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'epp_policy_template.docx'
            link.click()
          }).catch(error => console.error(error))
    }

  },
  mounted() {
    let self = this;
    let groupId = localStorage.getItem('groupId');
    if (this.displaySurveyMenu) {
      this.$http.get("survey/response/" + groupId,
          {
            headers: {
              'content-type': 'application/json'//,
            }
          })
          .then(result => {
            //let self = this;
            self.surveyData = result.data;
            localStorage.setItem('surveyResponseId', result.data._id);
            this.$store.commit('user/surveyResponseId', result.data._id);
            localStorage.setItem('surveyKey', result.data.surveyKey);
            this.$store.commit('user/surveyKey', result.data.surveyKey);

            /*           if (self.displayWineryMenu) {
                         this.$http.get("survey/full/" + result.data.surveyKey)
                             .then(result => {
                               //let self = this;
                               self.json = result.data;
                               self.survey = new SurveyVue.Model(self.json);

                               self.surveys = doReduction(self.survey.pages);
                               console.log("The grouped");
                               console.log(self.surveys);
                             })
                             .catch(
                                 error => {
                                   console.log(error)
                                 });
                       } else {

             */
            //this.$http.get("/vineyard/menu/6048e93494449252c5265879")
            console.log("Display Survey Menu: ", this.displaySurveyMenu);
            this.$http.get(`vineyard/${groupId}/menu`)
                  .then(response => {
                    self.menuObject = response.data;
                    console.log("Menu Object:");
                    console.log(self.menuObject);
                  })
                  .catch(
                      error => {
                        console.log(error)
                      });
            //}
          })
          .catch(err => {
            console.log(err)
          });
    }
  }
}
</script>


<style scoped>
a {
  color: #28763a;;
}

.card {
  display: inline-block;
  height: 120px;
  width: 30%;
  border: thin #1b1e21;
  margin: 5px;
  text-align: center;
}

.card-holder {
  width: 100%;
  margin-top: 10px;
}

.tier-benefits {
  margin: 3px;
}

.background-grey {
  background-color: #f8f8f8;
}

element.style {
}

.background-grey {
  background-color: #f8f8f8;
}

.columns-content {
  position: relative;
  border: 1px solid rgb(244, 244, 244);
  -webkit-box-shadow: 0 1px 1px 0 rgba(238, 238, 238, 1);
  -moz-box-shadow: 0 1px 1px 0 rgba(238, 238, 238, 1);
  box-shadow: 0 1px 1px 0 rgba(238, 238, 238, 1);
  padding: 10px 0 0;
  margin-bottom: 30px;
  /* margin: 0 40px 50px; */
  min-height: 100px;
}

.clear:after {
  display: block;
  content: '';
  clear: both;
}

.full-width .nav-tabs .nav-item {
  margin-bottom: -1px;
  flex-grow: 1;
  text-align: center;
}

.full-width .card-header-tabs {
  margin-right: -21px;
  margin-left: -21px;
}

.columns-content {
  position: relative;
  border: 1px solid rgb(244, 244, 244);
  -webkit-box-shadow: 0 1px 1px 0 rgba(238, 238, 238, 1);
  -moz-box-shadow: 0 1px 1px 0 rgba(238, 238, 238, 1);
  box-shadow: 0 1px 1px 0 rgba(238, 238, 238, 1);
  padding: 15px 0 0;
  margin-bottom: 30px;
  /* margin: 0 40px 50px; */
  min-height: 100px;
}

.short-articles, .tier-info {
  margin-bottom: 15px;
  word-wrap: break-word;
  font-size: 16px;
  font-family: "Lato", sans-serif;
  font-weight: 400;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  float: left;
  width: 100%;
  border-radius: 30px;
}

.admin-survey-list {
  border-radius: 15px;
  padding: 10px 0px;
  background-color: rgb(248, 248, 248);
  height: 650px;
  overflow: auto;
}

</style>
